<script>
    import { getIbeHost, getJson } from "shared/Utilities/fetchUtilities";
    import f9checkbox2 from "shared/Components/Inputs/f9checkbox2.vue";
    import f9select2 from "shared/Components/Inputs/f9select2.vue";
    import f9date2 from "shared/Components/Inputs/f9date2.vue";
    import f9button2 from "shared/Components/Inputs/f9button2.vue";
    import f9passengerPicker from "shared/Components/Inputs/f9passengerPicker.vue";
    import f9field2 from 'inputs/f9field2.vue';
    import f9radio from 'inputs/f9radio.vue';
    import BagPriceWidgetHeader from "./BagPriceWidgetHeader.vue";
    import { NewTripSearch } from "header/Models/bagPriceClasses";
    import moment from "moment";

    let dateFormat = "M/D/YYYY";//long: "dddd, MMMM Do YYYY" - Short: "M/D/YYYY"

    export default {
        props: {
            doneSearching: {
                type: Boolean,
                default: false
            },
            "validationScope": {
                type: String,
                default: "bag-price-new-trip"
            },
            value: {
                type: NewTripSearch,
                default: () => new NewTripSearch()
            }
        },
        mounted() {
            this.getFlightRoutes();
        },
        data() {
            return {
                dateFormatString: dateFormat,
                dateFormat: date => moment(date).format(dateFormat),
                minDate: moment().startOf('d').toDate(),
                currencyOptions: [
                    {
                        value: 'USD',
                        ariaLabel: 'United States Dollars',
                        text: 'USD'
                    }
                ],
                tripType: "Roundtrip",
                acceptTerms: false,
                searching: false,
                allFlightRoutes: { },
                originStations: [],
                originDisabledDates: [],
                originMaxDate: new Date(),
                destinationStations: [],
                destinationDisabledDates: [],
                destinationMaxDate: new Date(),
                retrievingDepartureDate: false,
                retrievingReturnDate: false,
                retrievingOrigins: false,
                retrievingDestinations: false,
                departOpenDate: new Date(),
                returnOpenDate: moment().add(1, "day").toDate(),
                validateOnChange: true
            }
        },
        computed: {
            originStationsSorted() {
                return this.sortStationList(this.originStations);
            },
            destinationStationsSorted() {
                return this.sortStationList(this.destinationStations);
            }
        },
        methods: {
            ibeHost() {
                return getIbeHost();
            },
            search() {
                this.validate(this.validationScope).then(result => {
                    if(result) {
                        this.searching = true;
                        this.$emit("search", this.value);
                    }
                });
            },
            updateTripType(newTripType) {
                this.tripType = newTripType;
                if (this.tripType === "One Way") {
                    this.value.returnDate = null;
                }
            },
            getFlightRoutes() {
                this.retrievingOrigins = true;
                getJson(this.ibeHost() + "/Resource/GetActiveMarkets")
                .then(x => {
                    if(x) {
                        this.allFlightRoutes = x;
                        this.allFlightRoutes.marketDetails.forEach(marketDetail => {
                            this.setStationData(this.originStations, marketDetail);
                        });
                    }
                }).catch(error => console.error(error))
                .then(() => {
                    this.retrievingOrigins = false;
                });
            },
            getFlightDates() {
                //Reset the disabled dates before we search for a new flight schedule
                this.originDisabledDates = [];
                this.destinationDisabledDates = [];
                this.retrievingDepartureDate = true;
                this.retrievingReturnDate = true;
                return Promise.all([
                    getJson(this.ibeHost() + 
                        `/Flight/RetrieveSchedule?calendarSelectableDays.Origin=${this.value.origin}&calendarSelectableDays.Destination=${this.value.destination}`)
                        .then(x => {
                            if(x) {
                                this.originDisabledDates = x.calendarSelectableDays.disabledDates;
                                this.originMaxDate = moment(x.calendarSelectableDays.lastAvailableDate).toDate();
                            }
                    }).catch(error => console.error(error))
                    .then(() => this.retrievingDepartureDate = false),
                    getJson(this.ibeHost() + 
                        `/Flight/RetrieveSchedule?calendarSelectableDays.Origin=${this.value.destination}&calendarSelectableDays.Destination=${this.value.origin}`)
                        .then(x => {
                            if(x) {
                                this.destinationDisabledDates = x.calendarSelectableDays.disabledDates;
                                this.destinationMaxDate = moment(x.calendarSelectableDays.lastAvailableDate).toDate();
                            }
                    }).catch(error => console.error(error))
                    .then(() => this.retrievingReturnDate = false)
                ]);
            },
            setStationData(stations, marketDetail) {
                if(marketDetail) {
                    stations.push({
                        text: `${marketDetail.stationName}, ${marketDetail.state} (${marketDetail.stationCode})`,
                        value: marketDetail.stationCode,
                        ariaLabel: `${marketDetail.stationName}, ${marketDetail.state} (${marketDetail.stationCode})`,
                    });
                }
            },
            setDepartOpenDate() {
                let momentDate = this.value.departDate ? moment(this.value.departDate) : moment(),
                    dateIsValid = true;

                while(this.originDisabledDates.includes(momentDate.format(this.dateFormatString))) {
                    momentDate.add(1, "day");
                    dateIsValid = false;
                }

                this.departOpenDate = momentDate.toDate();

                if(!dateIsValid) {
                    this.value.returnDate = this.value.departDate = null;
                }
            },
            setReturnOpenDate() {
                let momentDate = moment(this.value.returnDate || this.value.departDate),
                    dateIsValid = true;
                if(momentDate.isValid()) {
                    if(!this.value.returnDate) {
                        momentDate.add(1, "day");
                    }

                    while(this.destinationDisabledDates.includes(momentDate.format(this.dateFormatString))){
                        momentDate.add(1, "day");
                        dateIsValid = false;
                    }

                    this.returnOpenDate = momentDate.toDate();
                    
                    if(!dateIsValid) {
                        this.value.returnDate = null;
                    }
                }

                if(this.value.returnDate && this.value.departDate && this.value.returnDate.getTime() < this.value.departDate.getTime()) {
                    this.value.returnDate = null;
                }
            },
            sortStationList(list) {
                return list.sort((a, b) => {
                    let x = a.text.toLowerCase(), y = b.text.toLowerCase();
                    if (x < y) { return -1; }
                    if (x > y) { return 1; }
                    return 0;
                });
            }
        },
        watch: {
            doneSearching(val) {
                if(val) {
                    this.searching = false;
                }
            },
            'value.origin':function (city) {
                if(city) {
                    this.retrievingDestinations = true;
                    this.destinationStations = [];
                    this.value.destination = "";
                    var selectedMarket = this.allFlightRoutes.markets.find(market => {
                        return (market.fromStation === city);
                    });
                    selectedMarket.toStations.forEach(station => {
                        var foundStation = this.allFlightRoutes.marketDetails.find(market => {
                            return (market.stationCode === station);
                        });
                        this.setStationData(this.destinationStations, foundStation);
                    });
                    this.retrievingDestinations = false;

                    this.$nextTick(() => this.$refs.destination.focus());
                }
            },
            'value.destination': function(city) {
                if(city && city !== "") {
                    this.getFlightDates().then(() => this.setDepartOpenDate());
                }
            }
        },
        components: {
            f9field2,
            f9checkbox2,
            f9radio,
            f9select2,
            f9date2,
            f9button2,
            f9passengerPicker,
            BagPriceWidgetHeader
        }
    }
</script>

<template>
    <div class="new-trip-container">
        <bag-price-widget-header></bag-price-widget-header>
        <div class="radio-button-container">
            <f9radio name="tripTypes" label="Roundtrip" :value="tripType" @change="updateTripType" input-emit-change />
            <f9radio name="tripTypes" label="One Way" :value="tripType" @change="updateTripType" input-emit-change />
        </div>
        <form class="new-trip-form">
            <div class="form-inputs">
                <f9field2 class="new-trip-field">
                    <span slot="label" class="new-trip-label">From *</span>
                    <f9select2 class="new-trip-input" name="from_station" v-model="value.origin" autocomplete="off" v-validate="'required'" data-vv-validate-on=""
                        :data-vv-scope="validationScope" :items="originStationsSorted" :loading="retrievingOrigins" ref="origin" @change="$refs.destination.focus()"></f9select2>
                </f9field2>
                <f9field2 class="new-trip-field">
                    <span slot="label" class="new-trip-label">To *</span>
                    <f9select2 class="new-trip-input" name="to_station" v-model="value.destination" autocomplete="off" v-validate="'required'" data-vv-validate-on="" 
                        :data-vv-scope="validationScope" :items="destinationStationsSorted" :loading="retrievingDestinations" :disabled="!value.origin"
                        ref="destination"></f9select2>
                </f9field2>
                <f9field2 class="new-trip-field">
                    <span slot="label" class="new-trip-label">Depart Date *</span>
                    <f9date2 :disabled="!value.destination" class="new-trip-input" name="depart_date" v-model="value.departDate" 
                        :format="dateFormatString" autocomplete="off" :required="true" :validation-scope="validationScope"
                        :open-date="departOpenDate" :min-date="minDate" :max-date="originMaxDate" :validate-on-change="validateOnChange"
                        :disable-dates="originDisabledDates" :loading="retrievingDepartureDate" ref="departDate" @change="setReturnOpenDate"></f9date2>
                </f9field2>
                <f9field2 v-if="tripType != 'One Way'" class="new-trip-field">
                    <span slot="label" class="new-trip-label">Return Date *</span>
                    <f9date2 class="new-trip-input" name="return_date" v-model="value.returnDate" :format="dateFormatString" autocomplete="off" :required="true"
                        :validation-scope="validationScope" :open-date="returnOpenDate" :disabled="!value.departDate" :min-date="value.departDate" 
                        :max-date="destinationMaxDate" :disable-dates="destinationDisabledDates" :loading="retrievingReturnDate" ref="returnDate" :validate-on-change="validateOnChange"></f9date2>
                </f9field2>
                <f9field2 class="new-trip-field">
                    <span slot="label" class="new-trip-label">Travelers *</span>
                    <f9passenger-picker v-model="value.passengers" ref="passengers"></f9passenger-picker>
                </f9field2>
                <f9field2 class="new-trip-field">
                    <span slot="label" class="new-trip-label">Currency</span>
                    <f9select2 @focusin.native="$refs.passengers.close()" class="new-trip-input" name="currency" type="text" autocomplete="off" :data-vv-scope="validationScope" 
                        :items="currencyOptions" v-model="value.currency" ref="currency"></f9select2>
                </f9field2>
                <f9field2 class="new-trip-checkbox-field">
                    <div class="new-trip-checkbox-container">
                        <f9checkbox2 v-model="acceptTerms" name="bag_prices_terms" v-validate="{ tcs_checked: 'receive bag prices' }" 
                        :data-vv-scope="validationScope" aria-label="Press enter to accept the following bag price terms. I understand that if I already booked, my prices may vary from those below. The only way to get accurate
                            pricing is to enter the flight confirmation number, or visit Manage My Booking to view prices and buy bags."></f9checkbox2>
                        <span class="checkbox-text">Yes, I accept the Bag Price Terms</span>
                        <span class="terms-details" id="bag-price-term-details">
                            I understand that if I already booked, my prices may vary from those below. The only way to get accurate
                            pricing is to enter the flight confirmation #, or visit “Manage My Booking” to view prices & buy bags. 
                        </span>
                    </div>
                </f9field2>
            </div>
            <f9button2 class="new-trip-search-button" ref="searchButton" name="submit" @click="search" :loading="searching">CHECK BAG PRICES</f9button2>
        </form>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .new-trip-container {
        width: 100%;
        height: 100%;
        background-image: linear-gradient(-1deg, #576e77 0%, #3b4e55 100%);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        line-height: normal;
        letter-spacing: normal;
        padding: 23px 31px 29px;
        
        .radio-button-container {
            padding-top: 13px;
            font-size: 12px;
            font-weight: 400;
            line-height: 20px;
            color: white;
        }

        .new-trip-form {
            display: flex;
            flex-direction: column;

            .form-inputs {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;

                .new-trip-field {
                    width: 315px;
                    padding-top: 10px;
                    margin-top: 0;
                    justify-content: flex-start;

                    .new-trip-label {
                        font-size: 12px;
                        color: white;
                    }

                    .new-trip-input {
                        margin-top: 7px;

                        @{deep} .f9datepicker {
                            .f9date {
                                width: 315px;
                            }
                        }
                    }
                }
                    
                .new-trip-checkbox-field {
                    width: 100%;
                    margin-top: 0;

                    @{deep} .slider-label {
                        padding-bottom: 0;
                    }

                    &[aria-invalid=true] {
                        .new-trip-checkbox-container {
                            border: 1px solid @ibe-text--red;

                            @{deep} .checkbox-container {
                                .checkmark {
                                    border: 1px solid @ibe-text--red;
                                }
                            }
                        }
                    }

                    .new-trip-checkbox-container {
                        display: block;
                        width: 100%;
                        padding: 8px 13px 12px 13px;
                        margin-top: 16px;
                        border-radius: 2px;
                        background-color: rgba(255,255,255, 0.05);

                        @media @IE11 {
                            padding-top: 6px;
                        }
                        
                        

                        @{deep} .checkbox-container {
                            .checkmark {
                                margin-top: 5px;
                            }
                        }

                        .checkbox-text {
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 15px;
                            color: white;
                            padding-left: 34px;
                        }

                        .terms-details {
                            display: inline-block;
                            font-size: 11px;
                            line-height: 15px;
                            color: @ibe-text--light-gray;
                            padding: 5px 0 0 34px;

                            @media @IE11 {
                                padding-top: 3px;
                            }
                        }
                    }
                }
                
            }
        }

        .new-trip-search-button {
            align-self: flex-end;
            width: 315px;
        }
    }

    @media @tablet {
        .new-trip-container {
            padding: 15px;

            .radio-button-container {
                padding-top: 9px;
            }

            .new-trip-form {
                .form-inputs {

                    @{deep} .passenger-picker-container {
                        width: 100%;

                        .dropdown {
                            width: 100%;
                        }
                    }

                    .new-trip-field {
                        width: 100%;
                        padding-top: 11px;
                    }

                    .new-trip-confirm-container {
                        padding-right: 5px;
                        margin-top: 22px;

                        .terms-details {
                            padding-right: 0;
                        }
                    }
                }
            }

            .new-trip-search-button {
                align-self: flex-start;
                width: 100%;
            }
        }
    }
</style>